<div
  class="checking-section"
  #checkingSection
  [ngStyle]="backgroundStyles"
  (click)="onSearchClick($event)"
>
  <app-tracking-page-header
    [noSidebar]="false"
    [noSidebarButton]="false"
    [trackingPage]="trackingPage"
    [searchPage]="true"
    [selectedId]="selectedVisualBuilderId"
    (selectBlock)="selectBlock.emit($event)"
    [isVisualBuilder]="isVisualBuilder"
    (changeLanguage)="changeLanguage.emit($event)"
  >
  </app-tracking-page-header>
  <app-tracking-page-search-form
    [trackingPage]="trackingPage"
    [selectedId]="selectedVisualBuilderId"
    (selectBlock)="selectBlock.emit($event)"
    [noNumbers]="noNumbers"
    [mode]="mode"
    [isVisualBuilder]="isVisualBuilder"
    (triggerSearchNumber)="triggerSearchNumber.emit($event)"
    (triggerBackToSearch)="triggerBackToSearch.emit($event)"
  ></app-tracking-page-search-form>
  <app-tracking-page-footer
    [trackingPage]="trackingPage"
    [noSidebar]="trackingPage?.sidebar?.sidebarField === null"
    [selectedId]="selectedVisualBuilderId"
    (selectItem)="selectBlock.emit($event)"
    [isVisualBuilder]="isVisualBuilder"
  >
  </app-tracking-page-footer>
</div>
<!-- /checking-section -->
